import { AnyAction } from "redux";

export default class Event {
    constructor(public type: string) { }

    toObject(): EventAction<this> {
        return Object.assign({}, this);
    }
}

export type EventAction<T extends Event> = Omit<T, 'toObject'> & AnyAction;